/**
 * @generated SignedSource<<9b496ca95cc79ae0beec1d15d79a48af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestoreTaskInput = {
  taskEventCount?: string | null;
  ignoreParent?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RestoreTaskMutation$variables = {
  input: RestoreTaskInput;
};
export type RestoreTaskMutation$data = {
  readonly restoreTask: {
    readonly restoredTaskEventCount: string | null;
  } | null;
};
export type RestoreTaskMutation = {
  variables: RestoreTaskMutation$variables;
  response: RestoreTaskMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RestoreTaskPayload",
    "kind": "LinkedField",
    "name": "restoreTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "restoredTaskEventCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestoreTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestoreTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "28c8a604c6f9a745e123f0f784d778a0",
    "id": null,
    "metadata": {},
    "name": "RestoreTaskMutation",
    "operationKind": "mutation",
    "text": "mutation RestoreTaskMutation(\n  $input: RestoreTaskInput!\n) {\n  restoreTask(input: $input) {\n    restoredTaskEventCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "780cb46e74944a2569c073dcfd2227d9";

export default node;
